import axios from "axios";

// Server URL
//  const axiosBaseUrl = axios.create({baseURL: "http://localhost:3111"});
//  const Url = "https://tough-ox-hospital-gown.cyclic.app"
// const Url = "http://localhost:9000"
const Url = "https://app.auctionegypt.com"

// const Url = "http://109.106.244.229"
// const Url = "http://auctionegypt.com"




// const axiosBaseUrl = axios.create({baseURL: "https://e-commerce-9kwf.onrender.com/api"});


export default Url;